import React, { ReactNode, useMemo } from 'react';
import { SectionWithProducts } from '@ordering/api/utils/groupProductsBySections';
import { OfferTypes } from '@ordering/utils/promotions';

interface MenuSectionsContextType {
  sections: SectionWithProducts[];
  sectionOffersByIdMap: Map<string, OfferTypes.OfferEntry>;
}

const MenuSectionsContext = React.createContext<MenuSectionsContextType | undefined>(undefined);

export const MenuSectionsProvider: React.FC<{ children: ReactNode; sections: SectionWithProducts[] }> = ({
  children,
  sections,
}) => {
  const sectionOffersByIdMap = useMemo(() => {
    const map = new Map<string, OfferTypes.OfferEntry>();
    for (const section of sections) {
      for (const entry of section.entries ?? []) {
        if ('offerId' in entry) {
          map.set(entry.offerId, entry);
        }
      }
    }
    return map;
  }, [sections]);

  return (
    <MenuSectionsContext.Provider value={{ sections, sectionOffersByIdMap }}>{children}</MenuSectionsContext.Provider>
  );
};

export const useMenuSections = () => {
  const context = React.useContext(MenuSectionsContext);
  if (!context) {
    throw new Error('useMenuSections must be used within a MenuSectionsProvider');
  }
  return context;
};
